var map = {
	"./card_bg_1.webp": 7904,
	"./card_bg_2.webp": 86221,
	"./card_bg_3.webp": 61282,
	"./card_bg_4.webp": 57183,
	"./card_bg_5.webp": 29244,
	"./card_bg_6.webp": 29753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98557;